import { bootstrapApplication } from '@angular/platform-browser';
import { Chart } from 'chart.js';
import { appConfig } from './app/app.config';
import { App } from './app/app';

Chart.defaults.font.family = "'Reddit Sans', sans-serif";

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
